<template>
  <div class="height-100 d-flex">
    <div class="authCard m-auto">
      <a href="https://smartstewards.com/" target="_blank"><img src="@/assets/smart-stewards.png" class="header-logo"
      height="85" width="85" alt="Logo"></a>
      <h3>Sign In</h3>
      <p class="secondary-text">Welcome back</p>
      <form class="auth-form" @submit="login">
        <div class="form-group">
          <input type="text" v-model="email" placeholder="Email Address" class="form-control"
          required>
        </div>

        <div class="form-group">
          <div class="password-input-wrapper">
            <input :type="showPassword ? 'text' : 'password'" v-model="password"
            placeholder="Password" class="form-control password-input"
            required>
            <button type="button" class="password-toggle-btn" @click="togglePassword">
              <span v-if="showPassword">👁️</span>
              <span v-else>👁️‍🗨️</span>
            </button>
          </div>
          <p v-if="error" class="error-msg">Invalid Email address or password</p>
        </div>

        <div>
          <button class="btn primary-btn btn-block" :disabled="isDisabled">
            <span v-if="!loading"> SIGN IN </span>
            <vue-loaders-ball-spin-fade-loader scale=".5" v-else>
            </vue-loaders-ball-spin-fade-loader>
          </button>
        </div>
      </form>
      <p class="open-sans"><span class="secondary-text">Forgot Password?</span>
      <router-link to="/forgot"> Reset </router-link></p>
      <p><span class="secondary-text">Don't have an account?</span> <router-link to="/signup">
      Sign up </router-link></p>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    isDisabled() {
      if (!this.email || !this.password) {
        return true;
      }
      return false;
    },
  },
  data() {
    return {
      email: '',
      password: '',
      loading: false,
      error: false,
      showPassword: false,
    };
  },
  methods: {
    togglePassword() {
      this.showPassword = !this.showPassword;
    },
    login(e) {
      e.preventDefault();
      this.loading = true;
      const data = { email: this.email, password: this.password };
      this.$store.dispatch('login', data).then(() => {
        this.loading = false;
        // Check if user has completed his profile, else redirect to account setup page
        this.$router.push('/');
        // if (!localStorage.getItem('getStarted')) {
        //   this.$router.push('/get-started');
        // } else {
        //   this.$router.push('/');
        // }
      }).catch(() => {
        this.loading = false;
        this.error = true;
      });
    },
  },
};
</script>

<style scoped>
  .d-flex{
    background-color: #FFF;
  }
  a {
    color: #EE0E4C;
  }

  .password-input-wrapper {
    position: relative;
    display: flex;
    align-items: center;
  }

  .password-input {
    padding-right: 45px;
  }

  .password-toggle-btn {
    position: absolute;
    right: 12px;
    background: none;
    border: none;
    cursor: pointer;
    font-size: 18px;
    color: #666;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
  }

  .password-toggle-btn:hover {
    color: #EE0E4C;
  }

  .password-toggle-btn:focus {
    outline: none;
  }
</style>
